import { render, staticRenderFns } from "./About.vue?vue&type=template&id=07daf944&scoped=true&"
import script from "./About.vue?vue&type=script&lang=js&"
export * from "./About.vue?vue&type=script&lang=js&"
import style0 from "./About.vue?vue&type=style&index=0&lang=less&"
import style1 from "./About.vue?vue&type=style&index=1&id=07daf944&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07daf944",
  null
  
)

export default component.exports